module.exports = __webpack_public_path__ + "static/media/phase1.8120abd3.jpg";